import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Hamburger.module.less';

class Hamburger extends Component {
  renderSpans() {
    const { numberOfSpans } = this.props;
    const spans = [];
    for (let i = 0; i < numberOfSpans; i += 1) {
      spans.push(<span key={`span ${i}`} />);
    }

    return spans;
  }

  render() {
    const { isActive, toggleActive, isHomeStoreActive } = this.props;

    return (
      <div
        className={classNames(styles.hamburger, {
          [styles.open]: isActive,
          [styles.isHomeStore]: isHomeStoreActive,
        })}
        role="button"
        onClick={toggleActive}
        aria-label="Mobile Menu"
      >
        {this.renderSpans()}
      </div>
    );
  }
}

Hamburger.defaultProps = {
  isActive: false,
  numberOfSpans: 4,
};

Hamburger.propTypes = {
  isActive: PropTypes.bool,
  numberOfSpans: PropTypes.number,
  toggleActive: PropTypes.func.isRequired,
  isHomeStoreActive: PropTypes.bool,
};

export default Hamburger;
